if (!customElements.get('announcement-ticker')) {
  class AnnouncementTicker extends HTMLElement {
    constructor() {
      super();
      this.ticker = this.querySelector('.ticker-content');
      this.tickerSpeed = this.ticker?.dataset.tickerSpeed || 30;
      this.init();
    }

    init() {
      if (!this.ticker) return;

      // Set animation speed from data attribute
      this.ticker.style.setProperty('--ticker-speed', `${this.tickerSpeed}s`);

      // Calculate the width for seamless looping
      this.adjustTickerSpeed();

      // Adjust on window resize
      window.addEventListener('resize', () => this.adjustTickerSpeed());
    }

    adjustTickerSpeed() {
      const tickerItems = this.ticker.children;
      if (tickerItems.length === 0) return;

      // Calculate total width of one set of items
      let totalWidth = 0;
      const itemCount = tickerItems.length / 2; // We duplicate items for seamless loop

      for (let i = 0; i < itemCount; i++) {
        totalWidth += tickerItems[i].offsetWidth;
      }

      // Adjust animation duration based on width for consistent speed
      const baseSpeed = parseFloat(this.tickerSpeed);
      const viewportWidth = window.innerWidth;
      const adjustedSpeed = (totalWidth / viewportWidth) * baseSpeed;

      this.ticker.style.animationDuration = `${adjustedSpeed}s`;
    }
  }

  customElements.define('announcement-ticker', AnnouncementTicker);
}
